import { FilterBody } from '@yes.technology/react-toolkit'

export const baseProps: Omit<FilterBody, 'query'> = {
  objectclass: '',
  pagination: {
    limit: 1,
    offset: 0
  },
  orderby: [],
  skip_relations: true,
  skip_metadata: true,
  project_fields: {
    start_date: 1
  }
}

export const defaultEventsProjectFileds = {
  uuid: 1,
  des: 1,
  holder_organization: 1,
  organizer_organization: 1,
  establishment: 1,
  start_date: 1,
  end_date: 1,
  city: 1,
  state: 1,
  document: 1,
  complement: 1,
  obs: 1,
  document_format: 1
}

export const defaultPageSizeByDevice = {
  mobile: 1,
  tablet: 2,
  desktop: 9
}
